<div class="form-group ">
    <div class="row">
        <div [ngClass]="portrait == true? 'col-12': 'col-6'" *ngIf="sendStatus != 3">
            <label for="phone_number">{{
                globalService.Get("CELLPHONE")
                }}</label>
            <div class="input-group" dir="ltr">
                <div class="input-group-prepend">
                    <div class="input-group-text">{{ dial_code }}</div>
                </div>
                <input type="text" OnlyNumber="true" [disabled]="sendStatus > 0 || (enabled == false)" id="phone_number"
                    [(ngModel)]="phone_number" (input)="phoneNumberChange($event)" class="form-control" [class.unconfirmedPhone]="phoneConfirmed == false"
                    autocomplete="off" />
            </div>
        </div>
        <div [ngClass]="portrait == true? 'col-12': 'col-6'"
            *ngIf="sendStatus == 0 && phone_number != null && phone_number.length > 9" class="mt-4">
            <div *ngIf="errorMessage == ''">
                <label class="mr-sm-3 mr-1">{{ 
                    globalService.Get("VERIFY_PHONE")

                    }}</label>
                <input type="button" class="btn btn-small btn-secondary" (click)="SendCode()"
                    [value]="globalService.Get('SEND_CODE')">
            </div>
            <div *ngIf="errorMessage != ''"> 
                <app-prompt-message [showForm]="errorMessage != ''" color="primary" (onClose)="Retry()"
                    [message]="errorMessage">
                </app-prompt-message>
                <div class="row">
                    <div class="col-6">
                        <input type="button" class="btn btn-small btn-block btn-primary" (click)="Retry()" value="Try Again"
                            >
                    </div> 
                    <div class="col-6">
                        <input type="button" class="btn btn-small btn-block btn-success"  (click)="Signup()"
                            value="Create Account">
                    </div>
                </div>                
            </div>            
        </div>
        <div [ngClass]="portrait == true? 'col-12': 'col-6'" *ngIf="sendStatus == 1">
            <label class="mt-3 mr-sm-3 mr-1">{{
                globalService.Get("ENTER_4DIGIT")
                }}</label>
            <div class="row">
                <div class="col-6">
                    <input type="text" OnlyNumber="true" id="verificationCode" maxlength="4"
                        [(ngModel)]="verificationCode" class="form-control" autocomplete="off">
                </div>
                <div class="col-6">
                    <input type="button" class="btn btn-small btn-secondary" (click)="VerifyCode()"
                        [value]="globalService.Get('VERIFY')">
                </div>
            </div>
        </div>
        <div [ngClass]="portrait == true? 'col-12': 'col-6'" *ngIf="sendStatus == 2">
            <label class="mr-sm-3 mr-1">{{
                globalService.Get("CLICK_TO_CHANGE")
                }}</label>

            <div>
                <input type="button" class="btn btn-small btn-secondary" (click)="Clear()"
                    [value]="globalService.Get('CLEAR')">
            </div>
        </div>
        <div [ngClass]="portrait == true? 'col-12': 'col-6'" *ngIf="sendStatus == 3">
            <span>Failed To Verify</span>
        </div>
    </div>
</div>